/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Trim_Event_Time_HelpInputs */

const en_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adjust the outcode of Audio Description Events when virtual audio rendering completes.`)
};

const fr_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster automatiquement le timecode de sortie des événements d'audiodescription lorsque le rendu audio virtuel est terminé.`)
};

const de_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ausgabe von Audiobeschreibungsereignissen wird automatisch angepasst, sobald das virtuelle Audio-Rendering abgeschlossen ist.`)
};

const it_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regola automaticamente l'outcode degli eventi di descrizione audio al termine del rendering audio virtuale.`)
};

const ru_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая корректировка выходного кода событий аудиоописания после завершения виртуального рендеринга звука.`)
};

const es_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta automáticamente el código de salida de los eventos de descripción de audio cuando se completa la representación de audio virtual.`)
};

const zh_cn2_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`虚拟音频渲染完成后，自动调整音频描述事件的输出代码。`)
};

const ja_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仮想オーディオのレンダリングが完了すると、オーディオ説明イベントの出力コードを自動的に調整します。`)
};

const hi_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्चुअल ऑडियो रेंडरिंग पूरी होने पर ऑडियो डिस्क्रिप्शन इवेंट्स के आउटकोड को स्वचालित रूप से समायोजित करें।`)
};

const pt_pt2_options_editor_auto_trim_event_time_help = /** @type {(inputs: Options_Editor_Auto_Trim_Event_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta automaticamente o código de saída dos eventos de descrição de áudio quando a renderização de áudio virtual for concluída.`)
};

/**
* | output |
* | --- |
* | "Automatically adjust the outcode of Audio Description Events when virtual audio rendering completes." |
*
* @param {Options_Editor_Auto_Trim_Event_Time_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_trim_event_time_help = /** @type {((inputs?: Options_Editor_Auto_Trim_Event_Time_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Trim_Event_Time_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_trim_event_time_help(inputs)
	if (locale === "de") return de_options_editor_auto_trim_event_time_help(inputs)
	if (locale === "it") return it_options_editor_auto_trim_event_time_help(inputs)
	if (locale === "ru") return ru_options_editor_auto_trim_event_time_help(inputs)
	if (locale === "es") return es_options_editor_auto_trim_event_time_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_trim_event_time_help(inputs)
	if (locale === "ja") return ja_options_editor_auto_trim_event_time_help(inputs)
	if (locale === "hi") return hi_options_editor_auto_trim_event_time_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_trim_event_time_help(inputs)
	return en_options_editor_auto_trim_event_time_help(inputs)
});